Storage.prototype.setItemExpire = (key, value, expire) => {
    const obj = {
        data: value,
        expire: expire + Date.now()
    };
    sessionStorage.setItem(key, JSON.stringify(obj));
}

Storage.prototype.getItemExpire = key => {
    if (sessionStorage.getItem(key)) {
        const obj = JSON.parse(sessionStorage.getItem(key))
        if (Date.now() > obj.expire) {
            sessionStorage.removeItem(key)
            return null
        }
        return obj.data
    }
    return null;
}
